// Shared token helpers for the email-template surfaces. Keep this file as the
// single source of truth for built-in token names + sample placeholders so the
// workflow editor, the settings page, and the toolbar all stay in sync.

export const KNOWN_TOKENS = new Set<string>([
  "OrgName",
  "OrgId",
  "BaseUrl",
  "FrontendUrl",
  "LoginUrl",
  "DashboardUrl",
  "ConfirmationUrl",
  "InviteUrl",
  "MagicLinkUrl",
  "PasswordResetUrl",
  "BrandColor",
  "BrandColorHover",
  "Email",
  "Token",
  "AccessLevel",
  "IsAdmin",
  "Redirect",
  "Title",
  "Content",
]);

/**
 * Find non-built-in tokens in `text`. Constructs a fresh RegExp per call so the
 * global-flag `lastIndex` can't leak across consumers.
 */
export function detectCustomTokens(text: string): string[] {
  const seen = new Set<string>();
  const re = /\{\{\s*([A-Za-z_][\w.]*)\s*\}\}/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(text)) !== null) {
    if (!KNOWN_TOKENS.has(m[1])) seen.add(m[1]);
  }
  return Array.from(seen).sort();
}

/**
 * Sample placeholder used when previewing an email with no real value bound for
 * a custom token. Check the more-specific forms before the generic `name`.
 */
export function exampleFor(token: string): string {
  const t = token.toLowerCase();
  if (t.includes("email")) return "user@example.com";
  if (t.includes("first")) return "Alex";
  if (t.includes("last")) return "Smith";
  if (t.includes("name")) return "Alex Smith";
  if (t.includes("url")) return "https://example.com/...";
  if (t.includes("id")) return "12345";
  if (t.includes("date") || t.includes("at")) return "2026-06-12";
  return "sample value";
}
